import { Link } from 'react-router-dom';

const stats = [
  { value: '2004', label: 'Founded', icon: 'ri-flag-line' },
  { value: '5,000+', label: 'Successful Moves', icon: 'ri-truck-line' },
  { value: '4.6★', label: 'Google Rating', icon: 'ri-star-fill' },
  { value: '3', label: 'SoCal Locations', icon: 'ri-map-pin-2-line' },
];

export default function AboutStory() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Story section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <span className="inline-block bg-orange-100 text-orange-600 text-sm font-bold px-4 py-2 rounded-full mb-5">
              Our Story
            </span>
            <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-6 leading-tight">
              20 Years of Moving People Forward in Southern California
            </h2>
            <p className="text-slate-600 text-base leading-relaxed mb-5">
              City to City Moving Company was founded with a simple belief: moving shouldn&apos;t be stressful. What started as a small local operation in the Coachella Valley has grown into one of Southern California&apos;s most respected moving companies — serving communities from Irvine to Indio and everywhere in between.
            </p>
            <p className="text-slate-600 text-base leading-relaxed mb-5">
              Our founder began his moving career working for a large national franchise and saw firsthand how big companies often sacrificed personal service for volume. City to City Moving was built to be different — a truly local, customer-first experience at every price point, every time.
            </p>
            <p className="text-slate-600 text-base leading-relaxed mb-8">
              Today, our experienced teams handle everything from studio apartment moves to full commercial office relocations — always with the same care, transparency, and respect that built our reputation over two decades.
            </p>
            <div className="flex flex-wrap gap-4">
              <a href="tel:7606257767"
                className="flex items-center gap-2 bg-gradient-to-r from-orange-500 to-red-500 text-white px-7 py-3.5 rounded-xl font-bold hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap">
                <i className="ri-phone-fill"></i>Call Us Today
              </a>
              <Link to="/services"
                className="flex items-center gap-2 border border-slate-300 text-slate-700 px-7 py-3.5 rounded-xl font-semibold hover:bg-slate-50 transition-all whitespace-nowrap">
                <i className="ri-grid-line"></i>Our Services
              </Link>
            </div>
          </div>
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/4c7f535e5fd0e3f6f3b9a088f4683057.jpg"
              alt="City to City Moving Company crew carrying furniture at a Southern California home"
              className="w-full rounded-3xl object-cover object-top"
              style={{ height: '520px' }}
            />
            <div className="absolute -bottom-6 -left-6 bg-slate-900 text-white rounded-2xl p-5">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-500 to-red-500 rounded-xl">
                  <i className="ri-shield-check-line text-xl text-white"></i>
                </div>
                <div>
                  <div className="font-black text-lg">Licensed &amp; Insured</div>
                  <div className="text-slate-400 text-xs">CPUC Registered Carrier</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((s) => (
            <div key={s.label} className="bg-orange-50 rounded-2xl p-6 border border-orange-100 text-center hover:-translate-y-1 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-500 to-red-500 rounded-xl mx-auto mb-4">
                <i className={`${s.icon} text-xl text-white`}></i>
              </div>
              <div className="text-2xl font-black text-orange-600 mb-1">{s.value}</div>
              <div className="text-xs font-semibold text-slate-500 uppercase tracking-wide">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
